import { render } from "./ThemeWarning.vue?vue&type=template&id=29088f0e"
import script from "./ThemeWarning.vue?vue&type=script&lang=js"
export * from "./ThemeWarning.vue?vue&type=script&lang=js"

import "./ThemeWarning.vue?vue&type=style&index=0&id=29088f0e&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.7.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__